// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 592 ? "c15bf2b0" : chunkId) + "." + {"415":"10bd39f3fb3ff629","478":"cf3d6c7d9bacdf85","592":"51404975156b4fea"}[chunkId] + ".js";
};